import { useApolloClient } from '@apollo/client';
import { signOut } from 'firebase/auth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { EventType } from '../../../apollo/__generated__/graphql';
import { useCurrentEventQuery } from '../../../event/hooks/useCurrentEventQuery';
import { firebaseAuth } from '../../../firebase/firebase.service';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { useLayoutContext } from './LayoutContext';

export const useLayout = () => {
  const navigate = useNavigate();
  const { isDrawerOpen, toggleDrawer } = useLayoutContext();
  const { data: currentEventData } = useCurrentEventQuery();
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);

  const { data: user } = useCurrentUserQuery();
  const apolloClient = useApolloClient();

  const onLogout = () => {
    setIsLogoutDialogOpen(true);
  };

  const onCancelLogout = () => {
    setIsLogoutDialogOpen(false);
  };

  const onConfirmLogout = async () => {
    await signOut(firebaseAuth);
    await apolloClient.clearStore();
    navigate('/');
  };

  const onDashboardPress = () => {
    navigate('/dashboard');
  };

  const onEventsPress = () => {
    navigate('/events');
  };

  const onAdminEventUsersPress = () => {
    navigate('/admin-event-users');
  };

  const onAdminUsersPress = () => {
    navigate('/users');
  };

  const onUserInfosPress = () => {
    navigate('/personal-information');
  };

  const onUserImagesPress = () => {
    navigate('/images');
  };

  const onEventRegisterPress = () => {
    navigate('/event-register');
  };

  const onCautionPress = () => {
    navigate('/caution');
  };

  const onPaymentPress = () => {
    navigate('/payment');
  };

  const onEventUsersPress = () => {
    navigate('/event-users');
  };

  const onAdminEventTransactionsPress = () => {
    navigate('/event-transactions');
  };

  const onAdminPlacesPress = () => {
    navigate('/places');
  };

  const onAdminBedroomsPress = () => {
    navigate('/admin-bedrooms');
  };

  const onAdminValidationPress = () => {
    navigate('/validation');
  };

  const onAdminDjRequestsPress = () => {
    navigate('/admin-dj-requests');
  };

  const onContactPress = () => {
    navigate('/contact');
  };

  const onBedroomPress = () => {
    navigate('/bedrooms');
  };

  const onCarpoolPress = () => {
    navigate('/covoiturage');
  };

  const onTargetPress = () => {
    navigate('/target');
  };

  const onTinderPress = () => {
    navigate('/tinder');
  };

  const onDjPress = () => {
    navigate('/dj');
  };

  const isAdmin = user?.currentUser?.isAdmin ?? false;
  const isStaff = user?.currentUser?.isStaff ?? false;
  const isValidator = user?.currentUser?.isValidator ?? false;
  const isValidated = currentEventData?.currentEvent?.isValidated ?? false;
  const isTargetEnabled =
    currentEventData?.currentEvent?.isTargetEnabled ?? false;
  const hasPaidTicket = currentEventData?.currentEvent?.hasPaidTicket ?? false;
  const isTentOnly =
    currentEventData?.currentEvent?.type === EventType.TentOnly;

  return {
    isDrawerOpen,
    toggleDrawer,
    onLogout,
    isLogoutDialogOpen,
    onCancelLogout,
    onConfirmLogout,
    isAdmin,
    isStaff,
    isValidator,
    onDashboardPress,
    onEventsPress,
    onAdminEventUsersPress,
    onAdminEventTransactionsPress,
    onAdminUsersPress,
    onUserInfosPress,
    onUserImagesPress,
    onEventRegisterPress,
    onCautionPress,
    onPaymentPress,
    onEventUsersPress,
    onContactPress,
    onAdminPlacesPress,
    onAdminBedroomsPress,
    onAdminValidationPress,
    onAdminDjRequestsPress,
    onBedroomPress,
    onCarpoolPress,
    hasPaidTicket,
    isTentOnly,
    onTargetPress,
    onTinderPress,
    onDjPress,
    isValidated,
    isTargetEnabled,
  };
};
